import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { When } from 'react-if';
import app from 'srcJs/App';

var Actions = function Actions(_ref) {
  var hide = _ref.hide,
      action = _ref.action,
      frozen = _ref.frozen,
      wait = _ref.wait;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(When, {
    condition: wait
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list__balance"
  }, /*#__PURE__*/React.createElement("span", {
    className: "color-858585"
  }, app.tForReact('base', 'Wait:'), ' ', wait))), /*#__PURE__*/React.createElement(When, {
    condition: frozen
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list__balance"
  }, /*#__PURE__*/React.createElement("span", {
    className: "color-858585"
  }, app.tForReact('base', 'Frozen:'), ' ', frozen))), action ? /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list__balance"
  }, /*#__PURE__*/React.createElement(MenuItem, {
    visible: Boolean(action),
    label: action.label,
    route: action.route,
    url: action.url,
    className: "btn btn-primary btn-block",
    onClick: function onClick() {
      hide();
    }
  })) : null);
};

export default Actions;